import authenticated from "../middleware/authenticated";
import authorized from "../middleware/authorized";

export default [
    {
        path: '/applicant',
        name: 'ApplicantLayout',
        meta: {
            middleware: [authenticated, authorized],
            roles: ['ROLE_APPLICANT'],
        },
        component: () => import(/* webpackChunkName: "ApplicantLayout" */ '../../views/applicant/Layout.vue'),
        children: [
            {
                path: '',
                name: 'Applicant',
                component: () => import(/* webpackChunkName: "Applicant" */ '../../views/applicant/Index.vue'),
            },
            {
                path: 'profile',
                name: 'ApplicantProfileDetail',
                component: () => import(/* webpackChunkName: "ApplicantProfileDetail" */ '../../views/applicant/profile/Detail.vue'),
            },
            {
                path: 'applications',
                name: 'ApplicantApplicationsLayout',
                component: () => import(/* webpackChunkName: "ApplicantApplicationsLayout" */ '../../views/applicant/applications/Layout.vue'),
                children: [
                    {
                        path: '',
                        name: 'ApplicantApplicationsList',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationsList" */ '../../views/applicant/applications/List.vue'),
                    },
                    {
                        path: 'answered',
                        name: 'ApplicantApplicationsAnswered',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationsAnswered" */ '../../views/applicant/applications/Answered.vue'),
                    },
                    {
                        path: 'expectedActions',
                        name: 'ApplicantApplicationsExpected',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationsAnswered" */ '../../views/applicant/applications/ExpectedActions.vue'),
                    },
                    {
                        path: 'inboxes',
                        name: 'ApplicantApplicationsInboxesList',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationsInboxesList" */ '../../views/applicant/applications/inboxes/List.vue'),
                    },
                    {
                        path: 'inboxes/:inboxId',
                        name: 'ApplicantApplicationsInboxesDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationsInboxesDetail" */ '../../views/applicant/applications/inboxes/Detail.vue'),
                    },
                ]
            },
            {
                path: 'application/create',
                name: 'ApplicantApplicationCreateLayout',
                component: () => import(/* webpackChunkName: "ApplicantApplicationCreateLayout" */ '../../views/applicant/application/CreateLayout.vue'),
                children: [
                    {
                        path: '',
                        name: 'ApplicantApplicationMainCreate',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationMainCreate" */ '../../views/applicant/application/main/Create.vue'),
                    },
                    {
                        path: 'repeated',
                        name: 'ApplicantApplicationMainRepeatedCreate',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationMainCreate" */ '../../views/applicant/application/main/RepeatedCreate.vue'),
                    }
                ]
            },
            {
                path: 'application/:applicationId',
                name: 'ApplicantApplicationLayout',
                component: () => import(/* webpackChunkName: "ApplicantApplicationLayout" */ '../../views/applicant/application/Layout.vue'),
                children: [
                    {
                        path: '',
                        name: 'ApplicantApplicationMainDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationMainDetail" */ '../../views/applicant/application/main/Detail.vue'),
                    },
                    {
                        path: 'edit',
                        name: 'ApplicantApplicationMainEdit',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationMainEdit" */ '../../views/applicant/application/main/Edit.vue'),
                    },
                    {
                        path: 'edit/repeated',
                        name: 'ApplicantApplicationMainRepeatedEdit',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationMainRepeatedEdit" */ '../../views/applicant/application/main/RepeatedEdit.vue'),
                    },
                    {
                        path: 'applicant/detail',
                        name: 'ApplicantApplicationApplicantDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationApplicantDetail" */ '../../views/applicant/application/applicant/Detail.vue'),
                    },
                    {
                        path: 'customer/detail',
                        name: 'ApplicantApplicationCustomerDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationCustomerDetail" */ '../../views/applicant/application/customer/Detail.vue'),
                    },
                    {
                        path: 'planners/list',
                        name: 'ApplicantApplicationPlannersList',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationPlannersList" */ '../../views/applicant/application/planners/List.vue'),
                    },
                    {
                        path: 'planners/create',
                        name: 'ApplicantApplicationPlannersCreate',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationPlannersCreate" */ '../../views/applicant/application/planners/Create.vue'),
                    },
                    {
                        path: 'planners/:plannerId/edit',
                        name: 'ApplicantApplicationPlannersEdit',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationPlannersEdit" */ '../../views/applicant/application/planners/Edit.vue'),
                    },
                    {
                        path: 'documents/detail',
                        name: 'ApplicantApplicationDocumentsDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationDocumentsDetail" */ '../../views/applicant/application/documents/Detail.vue'),
                    },
                    {
                        path: 'agreement/detail',
                        name: 'ApplicantApplicationAgreementDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationAgreementDetail" */ '../../views/applicant/application/agreement/Detail.vue'),
                    },
                    {
                        path: 'agreement/create',
                        name: 'ApplicantApplicationAgreementCreate',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationAgreementCreate" */ '../../views/applicant/application/agreement/Create.vue'),
                    },
                    {
                        path: 'agreement/:agreementId/edit',
                        name: 'ApplicantApplicationAgreementEdit',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationAgreementEdit" */ '../../views/applicant/application/agreement/Edit.vue'),
                    },
                    {
                        path: 'app-file/:appFileId/detail',
                        name: 'ApplicantApplicationAppFileDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationAppFileDetail" */ '../../views/applicant/application/app-file/Detail.vue'),
                    },
                    {
                        path: 'app-file/create',
                        name: 'ApplicantApplicationAppFileCreate',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationAppFileCreate" */ '../../views/applicant/application/app-file/Create.vue'),
                    },

                    {
                        path: 'comments/detail',
                        name: 'ApplicantApplicationCommentsDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationCommentsDetail" */ '../../views/applicant/application/comments/Detail.vue'),
                    },
                    {
                        path: 'documents-versions/:documentsVersionId/detail',
                        name: 'ApplicantApplicationDocumentsVersionDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationDocumentsVersionDetail" */ '../../views/applicant/application/documents-versions/Detail.vue'),
                    },
                    {
                        path: 'payments',
                        name: 'ApplicantApplicationPaymentsDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationPaymentsDetail" */ '../../views/applicant/application/payments/Detail.vue'),
                    },
                    {
                        path: 'conclusion/:conclusionId',
                        name: 'ApplicantApplicationConclusionDetail',
                        component: () => import(/* webpackChunkName: "ApplicantApplicationConclusionDetail" */ '../../views/applicant/application/conclusion/Detail.vue'),
                    },
                ]
            },
        ]
    },
];
